module.exports = __webpack_public_path__ + "static/media/13.0c3b3b4c.png";